<template>
    <div v-if="widgetReady">
        <ac-modal :title="''" :size-class="'modal-md'" ref="modal">
            <template slot="header">
                <div class="row">
                    <div class="box-icon-avatar"
                            style="width: 130px; height: 130px;">
                        <img :src="profilePicture" class="box-icon-img">
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <a href="#" @click.prevent="goToDashboard">
                            <h4 class="text-center">
                                <span>{{vm.name}}</span>
                                &nbsp;&nbsp;<i class="fa fa-pencil-square-o fa-lg acressaGreenText"></i>
                            </h4>
                        </a>
                    </div>
                </div>
            </template>
            <template>
                <div class="row">
                    <div class="col-xs-6">
                        <h5><span>{{entityTypeName}}</span> Information</h5>
                        <address>
                            {{vm.address1}}&nbsp;
                            <span v-if="vm.address2">{{vm.address2}} </span>
                            <br/>{{vm.city}}&nbsp;
                            {{vm.stateProvinceCode}}&nbsp;
                            {{vm.zipCode}}
                            <br>
                            {{vm.phoneNumber | phoneNumber}}
                        </address>
                        <br>
                    </div>
                    <div class="col-xs-6">
                        <h5>
                            Primary Contact
                        </h5>
                        <span>{{vm.firstName}} {{vm.lastName}}</span><br/>
                        <span>{{vm.emailAddress}}</span><br/>
                        <span>{{vm.contactPhoneNumber | phoneNumber}}</span>
                    </div>
                </div>
                <div v-if="userCanEdit"> 

                    <invoice v-model="vm" :isEdit="true" v-if="vm.parentControlsInvoice && !isPhysician">
                    </invoice>

                    <div v-if="vm.parentReceivesPayment">
                        <div class="row">
                            <div class="col-xs-7">
                                <p>
                                    Manage Accresa Payments:
                                </p>
                            </div>
                            <div class="col-xs-5">
                                <div class="switch">
                                    <label class="pull-right">
                                        No
                                        <input type="checkbox" v-model="vm.receivesPayment"
                                                @change="toggleReceivesPayment($event)">
                                        <span class="lever"></span> Yes
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row alert alert-warning">
                            <span class="col-lg-1 fa fa-2x fa-exclamation-circle"></span>
                            <div class="col-lg-11">
                                When set to "Yes"
                                <span class="acressaBlueText">{{vm.name}}</span>
                                will receive payments directly.
                                The profile for <span class="acressaBlueText">{{vm.name}}</span>
                                will need current banking information saved if this option is
                                enabled.
                            </div>
                        </div>
                    </div>

                    <hr v-if="vm.parentReceivesPayment"/>
                    <div class="row" v-if="vm.parentControlsPlans">
                        <div class="col-xs-7">
                            <p>Controls Group Offering:</p>
                        </div>
                        <div class="col-xs-5">
                            <div class="switch">
                                <label class="pull-right">
                                    No
                                    <input type="checkbox" v-model="vm.controlsPlans"
                                            @change="toggleControlPlans($event)">
                                    <span class="lever"></span> Yes
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row alert alert-warning" v-if="vm.parentControlsPlans">
                        <span class="col-lg-1 fa fa-2x fa-exclamation-circle"></span>
                        <div class="col-lg-11">
                            When set to "Yes"
                            <span class="acressaBlueText">{{vm.name}}</span>
                            will be permitted to set their own membership
                            pricing and features. Leave this set to "No" if
                            <span class="acressaBlueText">{{vm.parentName}}</span>
                            will manage the membership pricing and features.
                        </div>
                    </div>

                    <hr/>
                    <div>
                        <div class="row">
                            <div class="col-xs-9">
                                <p>Process <span class="acressaBlueText">{{vm.name}}</span> for termination:</p>
                            </div>
                            <div class="col-xs-3">                
                                <ac-button class="btn-sm btn-red" :action="terminateProvider" v-if="userCanEdit">
                                    Terminate
                                </ac-button>
                            </div>
                        </div>
                        <div class="row alert alert-warning">
                            <span class="col-lg-1 fa fa-2x fa-exclamation-circle"></span>
                            <div class="col-lg-11">
                                This will schedule <span class="acressaBlueText">{{vm.name}}</span> for immediate termination.
                                All providers attached to them will be terminated. Any affiliations with them will also be terminated.
                                All patients who are on a plan owned by, or serviced by
                                <span class="acressaBlueText">{{vm.name}}</span> will have their plan terminated.
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </ac-modal>
        <termination-confirmation-modal ref="termModal">

        </termination-confirmation-modal>
    </div>
</template>

<script>
    import {common} from "../../../global/common.js";
    import {providerUtilities} from "./utilities.js";
    import {mapGetters} from 'vuex';
    import {api} from "../../../global/framework/api.js";
    import TerminationConfirmationModal from "./TerminationConfirmationModal.vue";
    import Invoice from './Invoice.vue';

    export default {
        name: "SettingsModal",
        components: {TerminationConfirmationModal, Invoice},
        data() {
            return {
                providerEntityId: 0,
                widgetReady: false,
                vm: {}
            }
        },
        computed: {
            ...mapGetters(['userCanEdit']),
            profilePicture() {
                return this.widgetReady ? common.generateImageLink(this.vm.profilePictureId, common.IMAGE_SIZE.MEDIUM.id) : '';
            },
            entityTypeName() {
                if (!this.widgetReady) {
                    return "";
                }
                let match = providerUtilities.getByEntityTypeId(this.vm.entityTypeId);
                return match.name;
            },
            isPhysician() {
                return this.entityTypeName == 'Physician';
            },
        },
        methods: {
            async showModal(providerEntityId) {
                this.providerEntityId = providerEntityId;
                let data = await api.get('ProviderEntity', this.providerEntityId, 'GetProviderInfoModal');
                this.mapData('vm', data);
                this.widgetReady = true;
                await this.$nextTick();
                this.$refs.modal.open();
                //console.log("Opening settings modal:", this.$refs.modal);
            },
            goToDashboard() {
                window.location.href = `/${this.entityTypeName.toLowerCase()}/#/${this.providerEntityId}/dashboard`;
            },
            toggleReceivesPayment() {
                //console.log("receives payment:", this.vm.receivesPayment);
                api.post('ProviderEntity', 'SaveReceivesPaymentSetting', {
                    providerEntityId: this.providerEntityId,
                    receivesPayment: this.vm.receivesPayment
                });
            },
            toggleControlPlans() {
                //console.log("controlPlans:", this.vm.controlsPlans);
                api.post('ProviderEntity', 'SaveControlsPlansSetting', {
                    providerEntityId: this.providerEntityId,
                    controlsPlans: this.vm.controlsPlans
                });
            },
            async terminateProvider() {
                await this.$refs.termModal.showModal({providerEntityId: this.providerEntityId});
            }
        }
    }
</script>

<style scoped>

</style>